// Confirmed by Jacky, 14 September 2026. Excluding GST. No sample quantities.
export const proposalPricingDefaults = {
    "supplierPricePolicy": {
        "missingEffectiveDate": "2026-01-01",
        "preferredPriceBasis": { "Paco": "COD" },
        "defaultPaymentTerms": "COD",
        "paymentTerms": { "Beaulieu": "EOD + 30 days", "Paco": "EOD + 30 days", "Armstrong": "EOD + 30 days", "Signature": "EOD + 30 days", "Intafloors": "EOD + 30 days" },
        "unselectedColour": "all-colour-range",
        "promotionNotice": "Promotional pricing — contact us to confirm availability."
    },
    "version": 1,
    "currency": "AUD",
    "gstRate": 0.1,
    "standardMarkup": 0.4,
    "premiumMarkup": 0.45,
    "premiumSuppliers": [
        "Preference",
        "Wonderwood",
        "Topdeck",
        "Top deck"
    ],
    "supplyMarkup": 0.2,
    "rates": [
        {
            "id": "removal-v2-0",
            "name": "Stretched carpet",
            "unit": "m\u00b2",
            "sell": 5,
            "material": null,
            "labour": null,
            "notes": "",
            "disposalSell": 3,
            "weight": 2,
            "dumpingRate": 0.5
        },
        {
            "id": "floating-material-0",
            "name": "Floating flooring \u2014 Laminate",
            "unit": "m\u00b2",
            "sell": 10,
            "material": null,
            "labour": 10,
            "notes": "",
            "disposalSell": 8,
            "weight": 9,
            "dumpingRate": 0.5
        },
        {
            "id": "floating-material-1",
            "name": "Floating flooring \u2014 Hybrid",
            "unit": "m\u00b2",
            "sell": 10,
            "material": null,
            "labour": 10,
            "notes": "",
            "disposalSell": 15,
            "weight": 13,
            "dumpingRate": 0.5
        },
        {
            "id": "floating-material-2",
            "name": "Floating flooring \u2014 Engineered timber",
            "unit": "m\u00b2",
            "sell": 10,
            "material": null,
            "labour": 10,
            "notes": "",
            "disposalSell": 12,
            "weight": 10,
            "dumpingRate": 0.5
        },
        {
            "id": "removal-v2-2",
            "name": "Direct glued carpet \u2014 broadloom",
            "unit": "m\u00b2",
            "sell": 12,
            "material": null,
            "labour": 10,
            "notes": "",
            "disposalSell": 3,
            "weight": 1.95,
            "dumpingRate": 0.5
        },
        {
            "id": "removal-v2-3",
            "name": "Direct glued carpet \u2014 tiles",
            "unit": "m\u00b2",
            "sell": 15,
            "material": null,
            "labour": 12,
            "notes": "",
            "disposalSell": 4,
            "weight": 4,
            "dumpingRate": 0.5
        },
        {
            "id": "removal-v2-4",
            "name": "Direct glued engineered timber",
            "unit": "m\u00b2",
            "sell": 25,
            "material": null,
            "labour": 20,
            "notes": "",
            "disposalSell": 12,
            "weight": 10,
            "dumpingRate": 0.5
        },
        {
            "id": "removal-v2-5",
            "name": "Nailed solid timber",
            "unit": "m\u00b2",
            "sell": 25,
            "material": null,
            "labour": 20,
            "notes": "",
            "disposalSell": 15,
            "weight": 17.1,
            "dumpingRate": 0.5
        },
        {
            "id": "removal-tile",
            "name": "Tiles \u2014 ceramic / porcelain",
            "unit": "m\u00b2",
            "sell": 30,
            "material": null,
            "labour": 25,
            "notes": "Old catalogue tile remove & dispose: selling $50/m\u00b2; external $35/m\u00b2 (supplier unspecified). These bundled rates are reference only; enter removal-only rates above.",
            "disposalSell": 20,
            "weight": 21,
            "dumpingRate": 0.5
        },
        {
            "id": "9",
            "name": "Concrete levelling",
            "unit": "bag",
            "sell": 85,
            "material": 20,
            "labour": 40,
            "notes": "Paco Maika720. Simple: 1 bag / 2m\u00b2. Primer additional treatment to confirm."
        },
        {
            "id": "10",
            "name": "Timber levelling",
            "unit": "bag",
            "sell": 120,
            "material": 36,
            "labour": 40,
            "notes": "Paco Maika620. Simple: 1 bag / 0.75m\u00b2. Gap filler likely; cost not supplied."
        },
        {
            "id": "11",
            "name": "Concrete primer 5kg",
            "unit": "bucket",
            "sell": 0,
            "material": 42,
            "labour": 0,
            "notes": "Customer will pay per bag compound , primer cost obsorbed "
        },
        {
            "id": "12",
            "name": "Concrete primer 20kg",
            "unit": "bucket",
            "sell": 0,
            "material": 120,
            "labour": null,
            "notes": "Customer will pay per bag compound, primer cost obsorbed - use this when job require large volume"
        },
        {
            "id": "13",
            "name": "Timber primer 5kg",
            "unit": "bucket",
            "sell": 0,
            "material": 38,
            "labour": null,
            "notes": "Customer will pay per bag compound , primer cost obsorbed "
        },
        {
            "id": "14",
            "name": "Timber primer 10kg",
            "unit": "bucket",
            "sell": 0,
            "material": 62,
            "labour": null,
            "notes": "Customer will pay per bag compound , primer cost obsorbed "
        },
        {
            "id": "15",
            "name": "Soudal gap filler",
            "unit": "unit",
            "sell": 35,
            "material": 16,
            "labour": 15,
            "notes": "Hard to say, maybe leave this one out and charge customer after lift off existing, charge per area gapped (unit = PC)"
        },
        {
            "id": "16",
            "name": "Grinding incl. dust extraction",
            "unit": "m\u00b2",
            "sell": 20,
            "material": null,
            "labour": 10,
            "notes": "Grind proud areas as appropriate."
        },
        {
            "id": "17",
            "name": "Feather coat finish",
            "unit": "m\u00b2",
            "sell": 20,
            "material": 3,
            "labour": 10,
            "notes": "Mandatory for vinyl unless already done."
        },
        {
            "id": "18",
            "name": "Sand particleboard joints",
            "unit": "building",
            "sell": 300,
            "material": null,
            "labour": 200,
            "notes": "Duplex = 2 buildings = $600 selling price."
        },
        {
            "id": "19",
            "name": "Plywood raising 9mm",
            "unit": "m\u00b2",
            "sell": 25,
            "material": 11,
            "labour": 6,
            "notes": "$33/sheet; costing coverage 3m\u00b2. Formula/rounding awaiting confirmation."
        },
        {
            "id": "20",
            "name": "Plywood raising 12mm",
            "unit": "m\u00b2",
            "sell": 25,
            "material": 12.5,
            "labour": 6,
            "notes": "$38/sheet; costing coverage 3m\u00b2. Formula/rounding awaiting confirmation."
        },
        {
            "id": "21",
            "name": "Plywood raising 15mm",
            "unit": "m\u00b2",
            "sell": 30,
            "material": 14.5,
            "labour": 6,
            "notes": "$43/sheet; costing coverage 3m\u00b2. Formula/rounding awaiting confirmation."
        },
        {
            "id": "22",
            "name": "Plywood raising 18mm",
            "unit": "m\u00b2",
            "sell": 35,
            "material": 17,
            "labour": 6,
            "notes": "$50/sheet; costing coverage 3m\u00b2. Formula/rounding awaiting confirmation."
        },
        {
            "id": "23",
            "name": "Move furniture",
            "unit": "room / area",
            "sell": 50,
            "material": null,
            "labour": 50,
            "notes": "YU cost $50; old catalogue sell $100. Select rooms in proposal; adjust for heavy items."
        },
        {
            "id": "24",
            "name": "Trim door",
            "unit": "door",
            "sell": 50,
            "material": null,
            "labour": 50,
            "notes": "YU cost $50. Proposed selling price equals external labour before any other costs."
        },
        {
            "id": "25",
            "name": "Install new skirting \u2014 concrete wall",
            "unit": "LM",
            "sell": 12,
            "material": null,
            "labour": 7,
            "notes": "YU generic install cost $5/LM; wall-specific rate needs confirmation."
        },
        {
            "id": "26",
            "name": "Install new skirting \u2014 plasterboard / timber",
            "unit": "LM",
            "sell": 10,
            "material": null,
            "labour": 6,
            "notes": "YU generic install cost $5/LM; confirm."
        },
        {
            "id": "27",
            "name": "Relay customer skirting \u2014 concrete wall",
            "unit": "LM",
            "sell": 12,
            "material": null,
            "labour": 10,
            "notes": "Remove and refit. No verified YU relay rate; confirm."
        },
        {
            "id": "28",
            "name": "Relay customer skirting \u2014 plasterboard / timber",
            "unit": "LM",
            "sell": 10,
            "material": null,
            "labour": 6,
            "notes": "Remove and refit. No verified YU relay rate; confirm."
        },
        {
            "id": "29",
            "name": "Supply skirting below 100mm",
            "unit": "LM",
            "sell": 10,
            "material": 3.5,
            "labour": null,
            "notes": "YU combined supply/install MDF material $3/LM reference; height not stated so not applied."
        },
        {
            "id": "30",
            "name": "Supply skirting above 100mm",
            "unit": "LM",
            "sell": 12,
            "material": 4.5,
            "labour": null,
            "notes": "Exactly 100mm not yet defined. Select material/specification before confirming cost."
        },
        {
            "id": "31",
            "name": "Artemis metro Sydney delivery",
            "unit": "delivery",
            "sell": 50,
            "material": null,
            "labour": 50,
            "notes": "Supply only default; adjust for distance or bulk."
        },
        {
            "id": "32",
            "name": "Supplier pickup",
            "unit": "pickup",
            "sell": 0,
            "material": 0,
            "labour": 0,
            "notes": "Customer pickup free."
        },
        {
            "id": "33",
            "name": "Optional moisture barrier",
            "unit": "m\u00b2",
            "sell": 2,
            "material": 0.5,
            "labour": 1,
            "notes": "No customer surcharge; record internal material/labour when selected."
        },
        {
            "id": "access-rubber3",
            "name": "Rubber underlay 3mm",
            "unit": "m\u00b2",
            "sell": 12,
            "material": 9,
            "labour": null,
            "notes": "1m \u00d7 1m sheet. Customer charge = material cost + $3/m\u00b2. Special underlay for timber flooring."
        },
        {
            "id": "access-rubber5",
            "name": "Rubber underlay 5mm",
            "unit": "m\u00b2",
            "sell": 13,
            "material": 10,
            "labour": null,
            "notes": "1m \u00d7 1m sheet. Customer charge = material cost + $3/m\u00b2. Special underlay for timber flooring."
        },
        {
            "id": "access-regupol",
            "name": "Regupol 5512 / Sonus Core 5mm",
            "unit": "m\u00b2",
            "sell": 17,
            "material": 12,
            "labour": null,
            "notes": "6.25m\u00b2/roll. Customer charge = material cost + $5/m\u00b2. Source: supplied price image."
        },
        {
            "id": "access-house",
            "name": "House \u2014 site surcharge",
            "unit": "job",
            "sell": 0,
            "material": null,
            "labour": null,
            "notes": "No site surcharge for a house."
        },
        {
            "id": "access-elevator",
            "name": "Unit / apartment \u2014 elevator access",
            "unit": "10kg product weight",
            "sell": 1,
            "material": null,
            "labour": null,
            "notes": "Customer surcharge = total product weight in kg \u00f7 10 \u00d7 $1. No rounding rule specified; do not silently round to whole 10kg blocks."
        },
        {
            "id": "access-stairs",
            "name": "Unit / apartment \u2014 stairs up to level 3",
            "unit": "10kg product weight",
            "sell": 2,
            "material": null,
            "labour": null,
            "notes": "Customer surcharge = total product weight in kg \u00f7 10 \u00d7 $2. Up to level 3 on foot. Not multiplied again by floor count. Above level 3: quote on demand."
        },
        {
            "id": "access-highstairs",
            "name": "Stairs above level 3",
            "unit": "quote on demand",
            "sell": null,
            "material": null,
            "labour": null,
            "notes": "Manual site quotation required. Blank selling value means quote on demand, not free."
        },
        {
            "id": "access-parking",
            "name": "No on-premises parking \u2014 unload then move vehicle",
            "unit": "job",
            "sell": 50,
            "material": null,
            "labour": null,
            "notes": "this is charge per day"
        },
        {
            "id": "access-half1",
            "name": "Job minimum \u2014 one person, half day",
            "unit": "minimum / job",
            "sell": 300,
            "material": null,
            "labour": null,
            "notes": "Minimum charge, not automatically added on top of the job. One of four alternatives; scope of minimum application to be settled in quoting engine."
        },
        {
            "id": "access-full1",
            "name": "Job minimum \u2014 one person, full day",
            "unit": "minimum / job",
            "sell": 500,
            "material": null,
            "labour": null,
            "notes": "Minimum charge; alternative to half-day and two-person rates."
        },
        {
            "id": "access-half2",
            "name": "Job minimum \u2014 two people, half day",
            "unit": "minimum / job",
            "sell": 500,
            "material": null,
            "labour": null,
            "notes": "Minimum charge for work requiring two people; alternative to one-person rates."
        },
        {
            "id": "access-full2",
            "name": "Job minimum \u2014 two people, full day",
            "unit": "minimum / job",
            "sell": 800,
            "material": null,
            "labour": null,
            "notes": "Minimum charge for work requiring two people; alternative to other minimum rates."
        }
    ],
    "installation": [
        {
            "id": "laminate",
            "name": "Laminate \u2014 floating",
            "unit": "m\u00b2",
            "labour": 15,
            "glue": 0,
            "glued": false,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "hybrid",
            "name": "Hybrid \u2014 floating",
            "unit": "m\u00b2",
            "labour": 15,
            "glue": 0,
            "glued": false,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "bamboo",
            "name": "Bamboo \u2014 floating",
            "unit": "m\u00b2",
            "labour": 15,
            "glue": 0,
            "glued": false,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "engineered",
            "name": "Engineered plank \u2014 floating",
            "unit": "m\u00b2",
            "labour": 23,
            "glue": 0,
            "glued": false,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "engineeredGlue",
            "name": "Engineered plank \u2014 direct glue",
            "unit": "m\u00b2",
            "labour": 35,
            "glue": 12,
            "glued": true,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "herringbone",
            "name": "Engineered herringbone \u2014 direct glue",
            "unit": "m\u00b2",
            "labour": 45,
            "glue": 12,
            "glued": true,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "chevron",
            "name": "Engineered chevron \u2014 direct glue",
            "unit": "m\u00b2",
            "labour": 50,
            "glue": 12,
            "glued": true,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "carpet",
            "name": "Broadloom carpet \u2014 LM, includes 8mm underlay",
            "unit": "LM",
            "labour": 40,
            "glue": 0,
            "glued": false,
            "underlay": 3.5,
            "upgrade": 2,
            "markup": 0.4
        },
        {
            "id": "carpetTile",
            "name": "Carpet tiles \u2014 direct glue",
            "unit": "m\u00b2",
            "labour": 15,
            "glue": 10,
            "glued": true,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "vinyl",
            "name": "Vinyl plank installation",
            "unit": "m\u00b2",
            "labour": 25,
            "glue": 10,
            "glued": true,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "sheetVinyl",
            "name": "Sheet vinyl \u2014 direct glue (Price my floor GM only)",
            "unit": "m\u00b2",
            "labour": 25,
            "glue": 10,
            "glued": true,
            "underlay": null,
            "upgrade": null,
            "markup": null
        },
        {
            "id": "solid",
            "name": "Solid timber \u2014 confirm method",
            "unit": "m\u00b2",
            "labour": 40,
            "glue": 0,
            "glued": false,
            "underlay": null,
            "upgrade": null,
            "markup": null
        }
    ],
    "rounding": { "totalTo": 1, "mode": "down" }
};
//# sourceMappingURL=proposal-pricing-defaults.js.map